// Make sure to update the translations json if you do any changes to these constants values
// since they're linked with the same value with lowercase

export const QUESTION_STEP = 'QUESTION_STEP';
export const REJECTION_REASONS_STEP = 'REJECTION_REASONS_STEP';
export const PARTIAL_DELIVERY_RESOLUTION_STEP = 'PARTIAL_DELIVERY_RESOLUTION_STEP';
export const DISSATISFIED_QUALITY_STEP = 'DISSATISFIED_QUALITY_STEP';
export const RECEIVED_NOTHING_STEP = 'RECEIVED_NOTHING_STEP';
export const NEED_REVISIONS_STEP = 'NEED_REVISIONS_STEP';
